document.addEventListener('click', async function (e) {
    const btnModalEditarZonaTrabajo = e.target.closest('#btnModalEditarZonaTrabajo');
    if (!btnModalEditarZonaTrabajo) return;

    const idZona      = btnModalEditarZonaTrabajo.getAttribute("data-id");
    const formEditar  = document.querySelector("#formEditarZonaTrabajo");
    const modalEditar = document.querySelector("#ModalEditarZonaTrabajo");

    if (!formEditar || !idZona || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar la zona de trabajo.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/zonas/infoZona?idZona=${idZona}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];
        

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información de la zona.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputIdZona   = formEditar.querySelector('#idZonaEditar');
        const inputNombre   = formEditar.querySelector('#nombreZonaEditarDisplay');
        const selectArea    = formEditar.querySelector('#idAreaEditarSelect');
        const divShitch     = formEditar.querySelector('#divShitchZona');

        if (inputIdZona) inputIdZona.value = data.idZona     || "";
        if (inputNombre) inputNombre.value = data.nombreZona || "";
        if (selectArea)  selectArea.value  = data.idArea     || "";

        const checked     = Number(data.estadoZona) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estadoZona) === 1 ? 'ACTIVA' : 'INACTIVA';

        divShitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input
                    id="estado"
                    type="checkbox"
                    name="estadoZona"
                    value="${data.estadoZona}"
                    ${checked}
                >
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información de la zona:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información de la zona.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarZonaTrabajo') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit  = formulario.querySelector('#btnEditarZonaTrabajo');
        const spinner    = formulario.querySelector('#spinner');
        const formData   = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar la zona de trabajo.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/zonas/editar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Zona de trabajo editada correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
